export default "\n\n<p class=\"text\">403 FORBIDDEN</p>\n<a [routerLink]=\"['/manage/home']\" routerLinkActive=\"router-link-active\" > Go home</a>\n";